import React from 'react';
import { I18n } from 'js/components/common/I18n';
import cls from 'js/utils/classNameBuilder.util';
import { Tooltip } from 'js/components/common/Tooltip';

import style from './Label.scss';

export const Label = ({ classNames = {}, id, hint = '', label, isLabelAsteriskEnabled, className = '', infoTooltip, readOnly = false, ...props }) => {
    const hintClassName = cls(['hint'], style, classNames);
    const hintContent = typeof hint === 'string'
        ? <I18n tKey={hint} defaultValue={hint} className={hintClassName} />
        : <span className={hintClassName}>{hint}</span>;

    return (
        <label
            className={`${cls(['label', readOnly && 'readOnly'], style, classNames)} ${className}`}
            htmlFor={id}
            {...props}
        >
            {label}
            {isLabelAsteriskEnabled && <span className={style.fieldLabelAsterisk}>*</span>}
            {label && infoTooltip && <Tooltip content={infoTooltip} className={style.tooltipIcon} />}
            {hint && hintContent}
        </label>
    );
};
